import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TemplateService } from './template.service';

const URL = `${environment.api_url}`;

@Injectable({
  providedIn: 'root'
})
export class CatalogService extends TemplateService {

  constructor(protected readonly http: HttpClient) {
      super(http);
  }

  getByNameWithParams(url, _params?) {
    const _url = `${URL}/${url}`;
    const httpOptions = { params: _params }
    return this.getOfURL(_url, httpOptions);
  }

  getOneByName(url) {
    const _url = `${URL}/${url}`;
    return this.getWhitoutId(_url);
  }

  getAllByName(url) {
    const _url = `${URL}/${url}`;
    return this.getAll(_url);
  }

  addOfURL(url, options?) {
    const _url = `${URL}/${url}`;
        return super.addOfURL(_url, options);
  }

  updateOfURL(url, options?) {
    const _url = `${URL}/${url}`;
    return super.updateOfURL(_url, options);
  }

  deleteOfURL(url, options?) {
    const _url = `${URL}/${url}`;
    return super.deleteOfURL(_url, options);
  }

  putOfURL(url, options?) {
    const _url = `${URL}/${url}`;
    const token = localStorage.getItem('token');
    const httpOptions = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    return this.http.put(_url, options, httpOptions);
  }
}
